import { createContext } from 'react';

/**
 * True once the flags for the signed-in user have settled - either Flagsmith answered, or
 * it failed and we gave up and fell back to flags-off.
 *
 * Read it with `useFeatureFlagsReady()` when a side effect must not run against
 * not-yet-loaded flags, e.g. firing a request only if a flag is on. Plain conditional
 * rendering does not need it: the component re-renders when the real flags arrive.
 *
 * This lives apart from the provider so `useFeatureFlags.ts` can read the context without
 * importing the provider and its Redux dependencies.
 */
export const FeatureFlagsReadyContext = createContext(false);
